import {env} from 'next-runtime-env';
import {UserOutlined} from '@ant-design/icons';

const NEXT_PUBLIC_URL = env('NEXT_PUBLIC_URL');

const PlayerIcon = (props: {
  icon: JSX.Element | string;
  // eslint-disable-next-line react/no-unused-prop-types
  iconWidthPx?: number;
  isImagePreview?: boolean;
}): JSX.Element => {
  const {icon, iconWidthPx, isImagePreview} = props;

  const getIcon = () => {
    const sizeProps = iconWidthPx ? {height: iconWidthPx, width: iconWidthPx} : null;
    let srcUrl: string = null;

    if (!icon) {
      srcUrl = '/sample/avatar1.svg';
      // return <UserOutlined style={{color: '#3a3a3a', fontSize: 30}} />;
    } else if (typeof icon === 'string') {
      if (icon.includes(NEXT_PUBLIC_URL)) {
        srcUrl = icon;
      } else if (isImagePreview) {
        srcUrl = `${icon}`;
      } else {
        srcUrl = `${NEXT_PUBLIC_URL}${icon}`;
      }
    }
    return <img src={srcUrl} {...sizeProps} />;
  };

  return getIcon();
};

export default PlayerIcon;
